import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { Flourish } from "./Flourish";
import { Sparkle } from "./Sparkle";

export const Philosophy = () => {
    const { t } = useLanguage();
    return (
        <section data-testid="philosophy-section" className="relative">
            <div className="max-w-[1100px] mx-auto px-6 lg:px-12 py-16 lg:py-20 text-center">
                <div
                    className="font-mono-archive text-[11px] mb-10 inline-flex items-center gap-2"
                    style={{ color: "var(--muted-ink)" }}
                >
                    <Sparkle size={12} />
                    {t("philo.eyebrow")}
                    <Sparkle size={12} />
                </div>

                <p
                    className="font-serif-display text-[32px] sm:text-[42px] lg:text-[54px] leading-[1.12]"
                    style={{ color: "var(--ink)" }}
                >
                    {t("philo.line1.a")}
                    <span
                        className="italic"
                        style={{ color: "var(--terracotta)" }}
                    >
                        {t("philo.line1.b")}
                    </span>
                    .
                    <br />
                    {t("philo.line2")}
                    <br />
                    <span className="italic" style={{ color: "var(--yellow-deep)" }}>
                        {t("philo.line3")}
                    </span>
                </p>

                <figure className="mt-12 max-w-[680px] mx-auto">
                    <blockquote
                        className="text-[17px] leading-[1.7] italic"
                        style={{
                            color: "var(--ink-soft)",
                            fontFamily: "Fraunces, serif",
                        }}
                    >
                        “{t("philo.body")}”
                    </blockquote>
                    <figcaption className="mt-5 flex items-center justify-center gap-3">
                        <span
                            className="w-10 h-px"
                            style={{ background: "var(--line)" }}
                        />
                        <span
                            className="font-serif-display text-[18px]"
                            style={{ color: "var(--ink)" }}
                        >
                            {t("philo.author")}
                        </span>
                        <span
                            className="font-mono-archive text-[10px]"
                            style={{ color: "var(--muted-ink)" }}
                        >
                            · {t("philo.author.role")}
                        </span>
                    </figcaption>
                </figure>

                <div className="mt-14 flex items-center justify-center">
                    <Flourish size={96} color="var(--terracotta)" />
                </div>
            </div>
        </section>
    );
};
